(() => {
  function init(root = document) {
    root.querySelectorAll('[data-event-submission]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const labels = JSON.parse(form.querySelector('[data-event-form-i18n]').textContent);
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const imageInput = form.querySelector('[name="image"]');
      const preview = form.querySelector('[data-event-image-preview]');
      form.querySelector('[name="request_id"]').value = crypto.randomUUID();
      let pending = false, previewUrl;
      const message = (text, failed = false) => {
        status.textContent = text;
        status.hidden = false;
        status.classList.toggle('cs-form-message--error', failed);
        status.classList.toggle('cs-form-message--success', !failed);
      };
      imageInput.addEventListener('change', () => {
        imageInput.setCustomValidity('');
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        preview.hidden = true;
        const file = imageInput.files[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png'].includes(file.type)) imageInput.setCustomValidity(labels.image_type);
        else if (file.size > 6 * 1024 * 1024) imageInput.setCustomValidity(labels.image_size);
        else {
          previewUrl = URL.createObjectURL(file);
          preview.src = previewUrl;
          preview.alt = form.querySelector('[name="image_alt"]').value || form.querySelector('[name="event_name"]').value;
          preview.hidden = false;
        }
        imageInput.reportValidity();
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        pending = true; button.disabled = true; form.setAttribute('aria-busy', 'true');
        message(labels.sending);
        try {
          const response = await fetch(form.action, {method:'POST',body:new FormData(form),credentials:'omit',signal:AbortSignal.timeout(65000)});
          const data = await response.json();
          if (!response.ok || data.ok !== true) throw new Error(labels.errors[data.error] || labels.error);
          message(labels.success);
          form.dataset.submissionId = data.id;
          form.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = true; });
          button.hidden = true;
        } catch (error) {
          message(error.name === 'TypeError' || error.name === 'TimeoutError' ? labels.error : error.message || labels.error, true);
          button.disabled = false;
        } finally {
          pending = false; form.removeAttribute('aria-busy'); status.focus({preventScroll:false});
        }
      });
      button.disabled = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
